import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import GenericCard from '../GenericCards/GenericCards';

export type PlanCardData = {
  planName: string;
  planDate: string;
  status: string;
  vestingPercentage: number;
  services: {
    hireDate: string;
    participationDate: string;
    totalVestingService: string;
    creditedServices: string;
  };
  keyDates: {
    fullyVestedDate: string;
    earlyRetirementDate: string;
    normalRetirementDate: string;
  };
};

export type PlanCardDataProps = React.PropsWithChildren<{
  cardData: PlanCardData;
}>;

const PlanCard = ({ cardData }: PlanCardDataProps) => {
  return (
    <Container className={'px-0 custom-plan-card'}>
      <GenericCard variant={'white'} className={'p-10 p-lg-11'}>
        <Row>
          <Col className={'col-12'}>
            <h2 className={'text-sm-20-lg-24'}>{cardData.planName}</h2>
          </Col>
          <Col className={'col-12 mt-0 mt-lg-3'}>
            <span className={'text-fs-6 text-light-grey fw-light'}>
              {cardData.planDate}
            </span>
          </Col>
        </Row>

        <Row className={'mt-7 mt-lg-10'}>
          <Col className={'col-12'}>
            <Row>
              <Col className={'col-6'}>
                <span className={'text-fs-6 text-lighter-grey fw-light'}>
                  Status
                </span>
              </Col>
              <Col className={'col-6 text-end'}>
                <span className={'text-fs-6 text-lighter-grey fw-light'}>
                  Vesting Percentage
                </span>
              </Col>
            </Row>
          </Col>
          <Col className={'col-12 mt-3'}>
            <Row>
              <Col>
                <span className={'text-sm-16-lg-20 fw-light'}>
                  {cardData.status}
                </span>
              </Col>
              <Col className={'text-end'}>
                <span
                  className={'text-sm-16-lg-20 fw-light'}
                >{`${cardData.vestingPercentage}%`}</span>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className={'mt-6 mx-0'}>
          <Col className={'col-12 py-3 px-0 col-12'}>
            <span className={'text-fs-6 fw-normal'}>Services</span>
          </Col>

          <Col className={'row-border-top px-0 py-3'}>
            <Row>
              <Col className={'col-7 pe-0'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  Hire Date
                </span>
              </Col>
              <Col className={'col-5 text-end'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  {cardData.services.hireDate}
                </span>
              </Col>
            </Row>
          </Col>

          <Col className={'col-12 row-border-top px-0 py-3'}>
            <Row>
              <Col className={'col-7 pe-0'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  Participation Date
                </span>
              </Col>
              <Col className={'col-5 text-end'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  {cardData.services.participationDate}
                </span>
              </Col>
            </Row>
          </Col>

          <Col className={'col-12 row-border-top px-0 py-3'}>
            <Row>
              <Col className={'col-7 pe-0'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  Total Vesting Service
                </span>
              </Col>
              <Col className={'col-5 text-end'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  {cardData.services.totalVestingService}
                </span>
              </Col>
            </Row>
          </Col>

          <Col className={'col-12 row-border-top px-0 py-3'}>
            <Row>
              <Col className={'col-7 pe-0'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  Credited Services
                </span>
              </Col>
              <Col className={'col-5 text-end'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  {cardData.services.creditedServices}
                </span>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className={'mt-6 mx-0'}>
          <Col className={'col-12 py-3 px-0 col-12'}>
            <span className={'text-fs-6 fw-normal'}>Key Dates</span>
          </Col>

          <Col className={'row-border-top px-0 py-3'}>
            <Row>
              <Col className={'col-7 pe-0'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  Fully Vested Dates
                </span>
              </Col>
              <Col className={'col-5 text-end'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  {cardData.keyDates.fullyVestedDate}
                </span>
              </Col>
            </Row>
          </Col>

          <Col className={'col-12 row-border-top px-0 py-3'}>
            <Row>
              <Col className={'col-7 pe-0'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  Early Retirement Date
                </span>
              </Col>
              <Col className={'col-5 text-end'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  {cardData.keyDates.earlyRetirementDate}
                </span>
              </Col>
            </Row>
          </Col>

          <Col className={'col-12 row-border-top px-0 py-3'}>
            <Row>
              <Col className={'col-7 pe-0'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  Normal Retirement Date
                </span>
              </Col>
              <Col className={'col-5 text-end'}>
                <span className={'text-fs-6 fw-light text-lighter-grey'}>
                  {cardData.keyDates.normalRetirementDate}
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </GenericCard>
    </Container>
  );
};

export default PlanCard;
